module.exports = __webpack_public_path__ + "img/pencil-icon.a3698d9f.svg";